export default {
	STORE: {
		LOCATION: {
			LAT: 37.614874,
			LNG: 140.209481
		},
		VALID: {
			DISTANCE: 0.3
		}
	}
}
